import type { ExternalProps } from "@gemini/core";
import { Box } from "@gemini/core";
import type { ReactElement } from "react";

type ListProps<Item extends object> = ExternalProps & {
  items: Array<Item>;
  renderItem: (item: Item) => ReactElement | ReactElement[];
};

export const List = <Item extends { key: string }>({
  items,
  renderItem,
  ...externalProps
}: ListProps<Item>) => {
  return (
    <Box
      as="ul"
      margin={0}
      overflowY="scroll"
      padding={0}
      flex={1}
      {...externalProps}
    >
      {items.map((item) => (
        <Box
          as="li"
          key={item.key}
          display="flex"
          flexDirection="column"
          borderBottomColor="color.surface.light.default"
          borderBottomStyle="solid"
          gap="spacing.8"
        >
          {renderItem(item)}
        </Box>
      ))}
    </Box>
  );
};
